import { Card, CardContent, CardHeader, Divider, IconButton } from '@mui/material';
import { Typography } from '@uhc-tempo/components';
import FlagIcon from '@mui/icons-material/Flag';
import CloseIcon from '@mui/icons-material/Close';

const ServiceSearchErrorCard = (props) => {
    const { classes, setCustomPopper, setMessage, optionsAvailable } = props;

    const clearButton = (
        <IconButton
            aria-label="Clear location"
            onClick={() => {
                setCustomPopper(false);
                setMessage(false);
            }}
            sx={{
                '&:focus': {
                    outline: '#196ecf auto 1px',
                },
            }}
        >
            <CloseIcon data-testid="clearLocationCustom1" />
        </IconButton>
    );

    return (
        <Card>
            <CardHeader sx={{ pt: 0, pb: 0 }} action={clearButton} />
            <CardContent sx={{ pt: 0, pb: 0 }}>
                <Typography.Paragraph>
                    <span
                        style={{
                            padding: '8px 14px',
                            borderRadius: '3px',
                            fontSize: '14px',
                            background: '#ADD8E6',
                        }}
                    >
                        <span
                            style={{
                                lineHeight: 2,
                                color: '#0008B',
                                position: 'relative',
                                top: '6px',
                            }}
                        >
                            {' '}
                            <FlagIcon />{' '}
                        </span>
                        <span style={{ paddingLeft: '5px', lineHeight: 2 }}>
                            To start a search: You must first choose a procedure or billing code
                        </span>
                    </span>
                </Typography.Paragraph>
            </CardContent>
            {optionsAvailable && (
                <Divider sx={classes.divider} data-testid="headerDivider"></Divider>
            )}
        </Card>
    );
};

export default ServiceSearchErrorCard;
